import PricingTemplate, {
  MONTHLY,
  MONTHLY_HASH_TAG,
  YEARLY,
  YEARLY_HASH_TAG
} from "../../../common/components/PricingTemplate";
import {RF_APP_LINK} from "../../../../utils/constants";
import {useRouter} from "next/router";
import {checkHashTag} from "../../../../helpers/checkHashTag";
import useTranslation from "next-translate/useTranslation";
import {RF_NAMESPACE} from "../../../../utils/i18nNameSpaces";
import {pricingPlans} from './pricingPlans';
import {useMemo} from 'react';

const Pricing = () => {
  const router = useRouter();
  const payment = checkHashTag(router, MONTHLY_HASH_TAG) && MONTHLY || checkHashTag(router, YEARLY_HASH_TAG) && YEARLY;
  const {t} = useTranslation(RF_NAMESPACE)
  const plans = useMemo(() => pricingPlans(t), [t, router]);
  return (
    <>
      <PricingTemplate namespace={RF_NAMESPACE} link={RF_APP_LINK} payment={payment} plans={plans}/>
    </>
  )
};

export default Pricing;
